// libs
import React from 'react';
import { MicrofrontendComponent, MicrofrontendShimmerComponent } from '@nykaa/mfa';

// urls
import { getMFABaseUrl } from 'shared/api/urls';

// helpers
import { onEventFailure } from 'shared/components/MFA/helpers';

// components
import ErrorBoundary from 'shared/components/CustomErrorBoundary';

const BASE_URL = getMFABaseUrl();
const PAGE_NAME = 'MFA ';
interface MFAProps {
  url?: string;
  moduleName?: string;
  modulePath?: string;
}

const MFA = ({
  url = '',
  moduleName = '',
  modulePath = ''
}: MFAProps) => {
  const MFUrl = BASE_URL + url;
  const handleEventFailure = (error: Error) => {
    onEventFailure(error, PAGE_NAME + moduleName);
  };

  if (__SERVER__) return <MicrofrontendShimmerComponent />;

  return (
    <ErrorBoundary
      FallbackComponent={<></>}
      onFailure={handleEventFailure}
    >
      <MicrofrontendComponent
        url={MFUrl}
        moduleName={moduleName}
        modulePath={modulePath}
        errorHandlerCallBack={handleEventFailure}
        props={{
          overrides: {
            root: {
              style: {
                padding: '0px',
              }
            }
          }
        }}
      />
    </ErrorBoundary>
  );

};

export default MFA;
